export default "__VITE_ASSET__c5ab8a5a__"